import { RULE_GRAPH_VERSION, type RuleGraphDto } from "@intelligems/ig-types";

/**
 * The graph the canvas shows while a rule's FIRST graph is still being
 * generated and there is no real structure to shimmer over: a generic
 * two-rule shape (two branch rows of three cards each) fed through the real
 * layout and render path in skeleton mode, so the loading state is the
 * canvas itself rather than a spinner. Labels are placeholders — skeleton
 * mode replaces every piece of text with shimmer bars.
 *
 * The shape deliberately satisfies the lane-refined layout (single
 * input/output/terminal, a simple fallback chain, each lane's pipeline
 * resolving), so it renders as the same rule rows a real graph will.
 */
export const RULE_GRAPH_SKELETON_PLACEHOLDER: RuleGraphDto = {
  version: RULE_GRAPH_VERSION,
  nodes: [
    { id: "sk-input", kind: "input", label: "Cart" },
    { id: "sk-b1", kind: "branch", label: "…" },
    { id: "sk-b1-source", kind: "generator", label: "…", branchId: "sk-b1" },
    { id: "sk-b1-filter", kind: "filter", label: "…", branchId: "sk-b1" },
    { id: "sk-b1-sort", kind: "sort", label: "…", branchId: "sk-b1" },
    { id: "sk-b2", kind: "branch", label: "…" },
    { id: "sk-b2-source", kind: "generator", label: "…", branchId: "sk-b2" },
    { id: "sk-b2-filter", kind: "filter", label: "…", branchId: "sk-b2" },
    { id: "sk-b2-sort", kind: "sort", label: "…", branchId: "sk-b2" },
    { id: "sk-output", kind: "output", label: "…" },
    { id: "sk-end", kind: "fallback-terminal", label: "…" },
  ],
  edges: [
    { from: "sk-input", to: "sk-b1", kind: "flow" },
    { from: "sk-b1", to: "sk-b1-source", kind: "flow" },
    { from: "sk-b1-source", to: "sk-b1-filter", kind: "flow" },
    { from: "sk-b1-filter", to: "sk-b1-sort", kind: "flow" },
    { from: "sk-b1-sort", to: "sk-output", kind: "flow" },
    { from: "sk-b1", to: "sk-b2", kind: "fallback" },
    { from: "sk-b2", to: "sk-b2-source", kind: "flow" },
    { from: "sk-b2-source", to: "sk-b2-filter", kind: "flow" },
    { from: "sk-b2-filter", to: "sk-b2-sort", kind: "flow" },
    { from: "sk-b2-sort", to: "sk-output", kind: "flow" },
    { from: "sk-b2", to: "sk-end", kind: "fallback" },
  ],
};
